import { render, staticRenderFns } from "./UDP.vue?vue&type=template&id=270e1020&scoped=true&"
import script from "./UDP.vue?vue&type=script&lang=ts&"
export * from "./UDP.vue?vue&type=script&lang=ts&"
import style0 from "./UDP.vue?vue&type=style&index=0&id=270e1020&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "270e1020",
  null
  
)

export default component.exports